<script>
    export let message = "";
    export let open = false;
</script>

<style>
    .fixed-alert {
        position: fixed;
        bottom: 2rem;
        left: 50%;
        width: 460px;
        max-width: 95%;
        transform: translateX(-50%);
        z-index: 1000;
        opacity: 1;
        background: #009401;
        color: #fff;
    }
</style>

{#if open}
    <div class="alert alert-success shadow-lg fixed-alert">
        <div>
            <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current flex-shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            <span>{ message }</span>
        </div>
    </div>
{/if}